import React from 'react';
import styles from './MedicalHistoryConfig.module.scss';
import MedicalHistoryConfigItem from './MedicalHistoryConfigItem';
import FlatList from '../../../../../Base/Components/FlatList';
import ScrollContainer from '../../../../../Base/Components/ScrollContainer';
import MedicalHistoryConfigControls from './MedicalHistoryConfigControls';
import OverlayLoading from '../../../../../../Components/OverlayLoading';
import { useMedicalHistoryTypeQuery } from '../../../../../../graphql/graphql';
import useFlatPages from '../../../../../Base/Hooks/useFlatPages';

interface Props {
	workplaceId: string;
}

const wrapperId = 'medicalHistoryConfig';

const MedicalHistoryConfig: React.FC<Props> = ({ workplaceId }) => {
	const { pagination, getNextPage } = useFlatPages();
	const { data, isLoading, refetch } = useMedicalHistoryTypeQuery({
		where: { workplaceId },
		pagination,
	});

	return (
		<div className={styles.wrapper}>
			{isLoading && <OverlayLoading />}
			<MedicalHistoryConfigControls onCreate={refetch} />
			<ScrollContainer wrapperId={wrapperId} className={styles.list}>
				<FlatList
					onRefresh={refetch}
					onLoadMore={getNextPage}
					data={data?.medicalHistoryType?.data || []}
					isLoading={isLoading}
					hasMoreData={data?.medicalHistoryType?.meta?.hasNextPage || false}
					scrollableTargetId={wrapperId}
					renderItem={item => (
						<MedicalHistoryConfigItem item={item} onChange={refetch} />
					)}
				/>
			</ScrollContainer>
		</div>
	);
};

export default MedicalHistoryConfig;
